'use strict';

/**
* checks recaptcha response in a specific recaptcha widget;
* specify widgetId in event data to find result of specific recaptcha instance
* @param {Object} event - event object
* */
function checkRecaptchaResponse(event) {
    if ($('#googleRecaptchaSiteKey').val()) {
        event.preventDefault();
        var recaptchaResponse = grecaptcha.getResponse(event.data.widgetId); // eslint-disable-line
        if (!recaptchaResponse) {
            event.stopImmediatePropagation();
            return;
        }
    }
}

module.exports = {
    recaptchaContactUs: function () {
        $('form.contact-us').submit({ widgetId: 0 }, checkRecaptchaResponse);
    }
};
